import { Component, ErrorInfo, ReactNode } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

interface IProps extends WithTranslation {
  children: ReactNode;
}

interface IState {
  hasError: boolean;
}

class ErrorBoundary extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error): IState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('ErrorBoundary caught an error', error, errorInfo);

    const errorMessage = error.message || 'No error message';
    const errorStack = error.stack || 'No stack trace';

    // Extract information from the errorInfo object
    const componentStack = errorInfo.componentStack || 'No component stack';

    const formData: Record<string, string> = {
      error: JSON.stringify({errorMessage, errorStack}, null, 2),
      errorInfo: JSON.stringify({componentStack}, null, 2)
    };

    fetch('/api/insert_error.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(formData)
    })
      .then(response => response.json())
      .then(data => {
        if (data.message) {
          console.log("insert_error.php:", data.message);
        } else {
          console.log("insert_error.php error:", data.error);
        }
      })
      .catch(error => console.error('Error:', error));
  
  }

  render(): ReactNode {
    const { t } = this.props;
    if (this.state.hasError) {
      return (
        <div style={{ margin: '20px', textAlign: 'center' }}>
            <h1>{t('unknown-error.title')}</h1>
            <p>{t('reload-to-try-again.text')}</p>
        </div>
      )
    }

    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
